/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ExternalUserInformation.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SD_USER_INFO = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `EXTERNALUSERINFORMATION/FETCH_SD_USER_INFO`
);

const FETCH_SD_USER_LOCAL_OFFICE_ADDRESS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `EXTERNALUSERINFORMATION/FETCH_SD_USER_LOCAL_OFFICE_ADDRESS`
);

export { FETCH_SD_USER_INFO, FETCH_SD_USER_LOCAL_OFFICE_ADDRESS };
